import React from 'react'
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav'
import PrimaryHeader from '../ui/PrimaryHeader'
import PrimaryFooter from '../ui/PrimaryFooter'
import './WebsiteLayout.scss'

function WebsiteLayout({ children, darkHeader }) {
  return (
    <>
      <SkipNavLink />
      <div className="website-layout">
        <PrimaryHeader darkHeader={darkHeader} />
        <SkipNavContent />
        <main>{children}</main>
        <PrimaryFooter />
      </div>
      {process.env.GATSBY_ACTIVE_ENV !== 'production' && (
        <div className="display-active-environment">{process.env.GATSBY_ACTIVE_ENV}</div>
      )}
    </>
  )
}

export default WebsiteLayout
